export const IOS_SITE_URL = "https://zksqh5.5535.cn/";
export const ANDROID_GUIDE_URL = "https://www.99sy.com/";
export const ANDROID_SCHEME = "aiqu://com.zhekoushenqi";
export const ANDROID_DOWNLOAD_URL =
  "https://qudao.zhekoushenqi.com/channel/oneGamebox/down?gid=1825&cpsuser=99sycom";

export function detectShareEnvironment(userAgent = "") {
  const ua = userAgent || (typeof navigator !== "undefined" ? navigator.userAgent : "");
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isAndroid = /Android/i.test(ua);
  const isWeChat = /MicroMessenger/i.test(ua);
  const isQQ = /(?:\sQQ\/|MQQBrowser)/i.test(ua);

  return {
    isIOS,
    isAndroid,
    isWeChat,
    isQQ,
    isInnerBrowser: isWeChat || isQQ,
  };
}

export function createAndroidAppOpener({
  scheme = ANDROID_SCHEME,
  downloadUrl = ANDROID_DOWNLOAD_URL,
  timeout = 1000,
} = {}) {
  let fallbackTimer = null;
  let pageWasHidden = false;

  const removeListeners = () => {
    if (typeof document !== "undefined") {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    }
    if (typeof window !== "undefined") {
      window.removeEventListener("pagehide", handlePageHide);
    }
  };

  const cancel = () => {
    if (fallbackTimer !== null) {
      window.clearTimeout(fallbackTimer);
      fallbackTimer = null;
    }
    removeListeners();
  };

  const markPageHidden = () => {
    pageWasHidden = true;
    cancel();
  };

  function handleVisibilityChange() {
    if (document.hidden) {
      markPageHidden();
    }
  }

  function handlePageHide() {
    markPageHidden();
  }

  const open = () => {
    if (typeof window === "undefined" || typeof document === "undefined") {
      return;
    }

    cancel();
    pageWasHidden = false;
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("pagehide", handlePageHide);

    fallbackTimer = window.setTimeout(() => {
      fallbackTimer = null;
      removeListeners();
      if (!pageWasHidden && !document.hidden) {
        window.location.href = downloadUrl;
      }
    }, timeout);

    window.location.href = scheme;
  };

  return { open, cancel };
}

export async function copyText(text) {
  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch (error) {
      // Continue with the legacy fallback for older in-app browsers.
    }
  }

  if (typeof document === "undefined") {
    throw new Error("Clipboard is unavailable");
  }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.top = "-9999px";
  textarea.style.left = "-9999px";
  textarea.style.opacity = "0";
  textarea.style.fontSize = "16px";
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  textarea.setSelectionRange(0, textarea.value.length);

  let copied = false;
  try {
    copied = document.execCommand("copy");
  } finally {
    textarea.remove();
  }

  if (!copied) {
    throw new Error("Clipboard copy failed");
  }
}
